<template>
    <div>
        <div class="row" style="text-align:center; margin-top:10px; margin-bottom:10px; font-size:0.8em;" >
            <b-progress-bar style="border-radius: 5px 0px 0px 5px;" class="col-md-2" v-bind:style="{'background-color': this.getRGB_fp(1)}">
                {{`&le; ${sextiles[0].toLocaleString(this.lang)} ${unit}`}}
            </b-progress-bar>
            <b-progress-bar class="col-md-2" v-bind:style="{'background-color': this.getRGB_fp(2)}">
                {{`&le; ${sextiles[1].toLocaleString(this.lang)} ${unit}`}}
            </b-progress-bar>
            <b-progress-bar class="col-md-2" v-bind:style="{'background-color': this.getRGB_fp(3)}">
                {{`&le; ${sextiles[2].toLocaleString(this.lang)} ${unit}`}}
            </b-progress-bar>
            <b-progress-bar class="col-md-2" v-bind:style="{'background-color': this.getRGB_fp(4)}">
                {{`&le; ${sextiles[3].toLocaleString(this.lang)} ${unit}`}}
            </b-progress-bar>
            <b-progress-bar class="col-md-2" v-bind:style="{'background-color': this.getRGB_fp(5)}">
                {{` &le; ${sextiles[4].toLocaleString(this.lang)} ${unit}`}}
            </b-progress-bar>
            <b-progress-bar style="border-radius: 0px 5px 5px 0px;" class="col-md-2" v-bind:style="{ 'background-color': this.getRGB_fp(6)}">
                {{`> ${sextiles[4].toLocaleString(this.lang)} ${unit}`}} 
            </b-progress-bar>
        </div>
    </div>
</template>
<script>

import * as helpers from '../helpers.js'

export default {

    props:{
        carac:String,
        sextiles:Array
    },

    mounted() {
    },
    
    data() {
        return {
            lang: navigator.language
        }
    },

    computed:{
        unit(){
            return this.$t(`caracs.${this.carac}.unit`)
        }
    },

    methods: {
        getRGB_fp(i) { return helpers.getRGB_fp(i) },
    },
}
</script>
<style scoped>
.progress-bar {
    color: #2c3e50;
    font-weight: bold;
}

</style>